import React, { memo } from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { cssTheme } from '@daedalus/atlas/themes';
const LoaderWrapper = /*#__PURE__*/styled('div')({
  name: "LoaderWrapper",
  class: "le4e2ph",
  propsAsIs: false
});
const LoadingIndicator = /*#__PURE__*/styled('div')({
  name: "LoadingIndicator",
  class: "lcv27uf",
  propsAsIs: false
});
const LoadingChevron = () => {
  return <LoadingIndicator>
      <svg viewBox="-20 0 41 75">
        <defs>
          <path d="M19.607,-10.516 C18.436,-11.688 16.536,-11.688 15.365,-10.516 C15.365,-10.516 0.001,4.848 0.001,4.848 
       C0.001,4.848 -15.364,-10.516 -15.364,-10.516 
       C-16.536,-11.688 -18.436,-11.688 -19.607,-10.516 
       C-20.779,-9.345 -20.779,-7.445 -19.607,-6.273 
       C-19.607,-6.273 -2.637,10.697 -2.637,10.697 
       C-1.919,11.414 -0.928,11.688 0.001,11.526 
       C0.929,11.688 1.919,11.414 2.635,10.697 
       C2.635,10.697 19.607,-6.273 19.607,-6.273 
       C20.779,-7.445 20.779,-9.345 19.607,-10.516z" fill={cssTheme.colors.content.special.c600} id="chevron" />
        </defs>
        <use href="#chevron" className="chevron" />
        <use href="#chevron" id="chevron2" className="chevron" />
      </svg>
    </LoadingIndicator>;
};
const _exp2 = /*#__PURE__*/() => Flex.Row;
const RedirectLoaderWrapper = /*#__PURE__*/styled(_exp2())({
  name: "RedirectLoaderWrapper",
  class: "r87zmc5",
  propsAsIs: true
});
const RedirectLoader = () => {
  return <RedirectLoaderWrapper justifyContent="center" alignItems="center" className="chromatic-ignore">
      <LoaderWrapper>
        <LoadingChevron />
      </LoaderWrapper>
    </RedirectLoaderWrapper>;
};
export default memo(RedirectLoader);

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");